export default {
  title: "Shaman",
  content: [
    "New ability: Totemic Recall: Removes all your totems and returns mana equal to 25% of their cost.",
    "Increased the radius of totems that affect friendly targets to 30 yards.",
    "Searing Totem now only attacks enemies that are in combat with the Shaman.",
    "Stoneskin Totem now also reduces damage taken from ranged attacks.",
    "Windwall Totem has been removed.",
  ],
};
